import React, {useState, useContext, Fragment} from "react" ;
import WieldySidebarMyAccount from "./WieldySidebarMyAccount";
import WieldySidebarTabs from "./WieldySidebarTabs";
import "./WieldySidebar.scss" ;
import SidebarChildren from "root/Wieldy/Sidebar/ChildSidebar/SidebarChildren";
import {HomePageTabs} from "root/DataFunctions/Constants";
import {ApplicationTypes, defaultTabForUser, doesRoleHaveTab, doesUserHaveApplication} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";
import SidebarTeam from "root/Wieldy/Sidebar/TeamSidebar/SidebarTeam";
import WieldySidebarSection from "root/Wieldy/Sidebar/WieldySidebarSection";
import WieldySidebarLink from "root/Wieldy/Sidebar/WieldySidebarLink";
import {
    PATH_DASHBOARD_ROOT,
    PATH_MESSAGING_ROOT,
    PATH_LETTERBOX_ROOT,
    PATH_POSTS_ROOT,
    PATH_RESOURCES_ROOT,
    PATH_ADMIN_ROOT_LINK,
    PATH_USERS_ROOT_LINK,
    PATH_MY_CONTRIBUTORS_ROOT,
    PATH_APPROVALS_ROOT,
    PATH_SAFEGUARDING_ROOT, PATH_SAFEGUARDING_ROOT_LINK, PATH_PRIVATE_MESSAGING_ROOT_LINK
} from "root/Wieldy/routePaths";

import SidebarContacts from "root/Wieldy/Sidebar/ContactSidebar/SidebarContacts";
import {useLocation} from "react-router-dom";
import phpVars from 'phpVars';

const WieldySidebar = ({height}) =>
{
    const globals = useContext(GlobalContext);

    const { pathname }  = useLocation();

    const homePageMappings = [
        { route: '/home/child', tab: HomePageTabs.CHILDREN },
        { route: '/home/team', tab: HomePageTabs.TEAM },
        { route: '/home', tab: defaultTabForUser ( globals.userType )},
    ]

    const getSelectedMenu = () =>
    {
        let selectedTab = HomePageTabs.HOME ;

        for ( let off = 0 ; off < homePageMappings.length ; off++)
        {
            if ( pathname.includes (homePageMappings[off].route ) && doesRoleHaveTab(homePageMappings[off].tab, globals.userType ))
            {
                selectedTab = homePageMappings[off].tab ;
                break ;
            }
        }

        return selectedTab ;
    }

    const [ activeTab, setActiveTab ] = useState ( getSelectedMenu() );

    const applicationMenuSection = () =>
    {
        const doesUserHaveletterbox = doesUserHaveApplication(ApplicationTypes.POSTBOX, globals.userType) || doesUserHaveApplication(ApplicationTypes.POSTBOX_APPROVER, globals.userType) ;
        const has_lifestory = phpVars.has_lifestory === 1 ? true :false;

        return (
            <Fragment>
                <WieldySidebarSection title='Apps' key='applications'>
                    { doesUserHaveApplication(ApplicationTypes.SYSADMIN, globals.userType) && <WieldySidebarLink link={PATH_ADMIN_ROOT_LINK} title='Domain Admin' iconName='icon-timeline' iconSize='icon-xl' keyName='root8' key='a8'/> }
                    { +globals.isEditor === 1 && <WieldySidebarLink link={PATH_APPROVALS_ROOT} title='To Approve' iconName='icon-important' iconSize='icon-xl' keyName='root6' key='a11'/> }
                    { doesUserHaveApplication(ApplicationTypes.ORGANISATION_ADMIN, globals.userType) && <WieldySidebarLink link={PATH_DASHBOARD_ROOT} title='Organisation Dashboard' iconName='icon-dashboard' iconSize='icon-xl' keyName='root5' key='a5'/> }
                    { doesUserHaveApplication(ApplicationTypes.MESSAGING, globals.userType) && <WieldySidebarLink link={PATH_MESSAGING_ROOT} title='My Messages' iconName='icon-chat' iconSize='icon-xl' keyName='root1' key='a1'/> }
                    { doesUserHaveApplication(ApplicationTypes.POSTS, globals.userType) && has_lifestory && <WieldySidebarLink link={PATH_POSTS_ROOT} title='My Posts' iconName='icon-camera' iconSize='icon-xl' keyName='root2' key='a2'/> }
                    { doesUserHaveletterbox  && <WieldySidebarLink link={PATH_LETTERBOX_ROOT} title='Letterbox' iconName='icon-email' iconSize='icon-xl' keyName='root3' key='a3'/> }
                    { /*doesUserHaveApplication(ApplicationTypes.COMMSPLANS, globals.userType) && <WieldySidebarLink link={PATH_COMMSPLANS_ROOT} title='Communication Plans' iconName='icon-timeline' iconSize='icon-xl' keyName='root4' key='a4'/> */}
                    { (doesUserHaveApplication(ApplicationTypes.USERS, globals.userType) || doesUserHaveApplication(ApplicationTypes.ORGANISATION_ADMIN, globals.userType)) && <WieldySidebarLink link={PATH_USERS_ROOT_LINK} title='Users' iconName='icon-family' iconSize='icon-xl' keyName='root6' key='a6'/> }
                    { doesUserHaveApplication(ApplicationTypes.RESOURCES, globals.userType) && has_lifestory && <WieldySidebarLink link={PATH_RESOURCES_ROOT} title='My Resources' iconName='icon-files' iconSize='icon-xl' keyName='root7' key='a7'/> }
                    { +globals.isManager === 1 && doesUserHaveApplication(ApplicationTypes.MY_CONTRIBUTORS, globals.userType) && <WieldySidebarLink link={PATH_MY_CONTRIBUTORS_ROOT} title='My Contributors' iconName='icon-family' iconSize='icon-xl' keyName='root10' key='a10'/> }
                    { doesUserHaveApplication(ApplicationTypes.CHILDREN, globals.userType) && <SidebarChildren height={height} role={globals.userType}/> }
                    { doesUserHaveApplication(ApplicationTypes.SAFEGUARDING, globals.userType) && <WieldySidebarLink link={PATH_SAFEGUARDING_ROOT_LINK} title='Safeguarding' iconName='icon-avatar' iconSize='icon-xl' keyName='root14' key='a14'/>}
                    { doesUserHaveApplication(ApplicationTypes.PRIVATE_MESSAGES, globals.userType) && <WieldySidebarLink link={PATH_PRIVATE_MESSAGING_ROOT_LINK} title='Private Messaging' iconName='icon-avatar' iconSize='icon-xl' keyName='root15' key='a15'/>}
                    { doesUserHaveApplication(ApplicationTypes.CONTACTS, globals.userType) && <SidebarContacts role={globals.userType}/> }
                </WieldySidebarSection>

            </Fragment>
        )
    }

    const shouldShowChildrenTab = activeTab === HomePageTabs.CHILDREN && doesRoleHaveTab(HomePageTabs.CHILDREN, globals.userType) ;
    const shouldShowTeamTab = activeTab === HomePageTabs.TEAM && (doesRoleHaveTab(HomePageTabs.TEAM, globals.userType) || doesUserHaveApplication(ApplicationTypes.ORGANISATION_ADMIN, globals.userType)) ;
    const shouldShowAppMenu = activeTab === HomePageTabs.HOME && doesRoleHaveTab(HomePageTabs.HOME, globals.userType) ;

    return (
        <Fragment>
            <div className="dt-sidebar__notification d-lg-block">
                <WieldySidebarMyAccount/>
                <WieldySidebarTabs activeTab={activeTab} onChangeActiveTab={setActiveTab}/>
            </div>

            { shouldShowChildrenTab === true && <SidebarChildren height={height} role={globals.userType}/>}
            { shouldShowTeamTab === true && <SidebarTeam height={height} role={globals.userType}/>}
            { shouldShowAppMenu === true && applicationMenuSection()}

        </Fragment>
    )
}

export default WieldySidebar;
